import React from 'react';
import PropTypes from 'prop-types';

import { StringConstantsMixin, replaceStrings } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

import styles from './styles/styles.module.scss';

const ShowMoreItems = ({ title, config, handler }) => {
  if (config.max >= config.total) {
    return null;
  }

  const showingStringsConfig = [
    { stringKey: 'min', stringValue: config.min },
    { stringKey: 'max', stringValue: config.max },
    { stringKey: 'total', stringValue: config.total }
  ];
  const showingStringsText = replaceStrings(StringConstantsMixin.strings.SEARCH.SHOWING_AMOUNT_OF_TOTAL, showingStringsConfig);
  const buttonStyles = `${styles.button} ${config.whiteBackground ? styles.whiteBackground : ''}`;
  return (
    <div className={`${styles.container} ${StringConstantsMixin.constants.XLATE.NONE}`}>
      <button className={buttonStyles} onClick={handler} title={title}>
        {title}
      </button>
      <div className={styles.showing}>{showingStringsText}</div>
    </div>
  );
};

ShowMoreItems.defaultProps = {};

ShowMoreItems.propTypes = {};

export default ShowMoreItems;
